var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVulnerability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vulnerability"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80836 17.5L13.9363 11.2314L9.5 6.9876L12.5157 2.50006C12.5105 2.50002 12.5052 2.5 12.5 2.5C12.2667 2.5 12.0333 2.54167 11.8 2.625L5.8 4.875C5.41667 5.025 5.10417 5.26667 4.8625 5.6C4.62083 5.93333 4.5 6.30833 4.5 6.725V11.45C4.5 13.7833 5.16667 15.9625 6.5 17.9875C7.83333 20.0125 9.625 21.4 11.875 22.15C11.975 22.1833 12.075 22.2083 12.175 22.225C12.275 22.2417 12.3833 22.25 12.5 22.25C12.6167 22.25 12.725 22.2417 12.825 22.225C12.925 22.2083 13.025 22.1833 13.125 22.15C15.375 21.4 17.1667 20.0125 18.5 17.9875C19.8333 15.9625 20.5 13.7833 20.5 11.45V6.725C20.5 6.30833 20.3792 5.93333 20.1375 5.6C19.8958 5.26667 19.5833 5.025 19.2 4.875L15.2996 3.41237L12.6688 6.9876L15.7995 11.132L9.80836 17.5Z",
    fill: "#4C4948"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVulnerability);
export default __webpack_public_path__ + "static/media/vulnerability.6567f46270d9be7ec88ec4027703a3ef.svg";
export { ForwardRef as ReactComponent };